import { FC } from 'react';
import { OfferLetterChecklistStep } from 'src/features/proofs/offerLetterChecklistConfig';
import { CheckStatus } from '../hooks/useOfferLetterChecklist';
import {
  OfferLetterCheckItemButtons,
  OfferLetterCheckItemInfo,
  OfferLetterCheckItemLabel,
  OfferLetterCheckItemRow,
  OfferLetterPassFailButton,
  OfferLetterTooltipContent,
  OfferLetterTooltipIcon,
  OfferLetterTooltipWrapper
} from '../styles';

interface OfferLetterCheckItemProps {
  item: OfferLetterChecklistStep;
  status: CheckStatus;
  onSetCheck: (value: CheckStatus) => void;
}

const OfferLetterCheckItem: FC<OfferLetterCheckItemProps> = ({ item, status, onSetCheck }) => {
  const handleToggle = (value: 'pass' | 'fail') => {
    onSetCheck(status === value ? 'unset' : value);
  };

  return (
    <OfferLetterCheckItemRow>
      <OfferLetterCheckItemInfo>
        <OfferLetterCheckItemLabel>
          {item.label}
          <OfferLetterTooltipWrapper>
            <OfferLetterTooltipIcon type="button" aria-label="Show criteria">
              ?
            </OfferLetterTooltipIcon>
            <OfferLetterTooltipContent>{item.criteria}</OfferLetterTooltipContent>
          </OfferLetterTooltipWrapper>
        </OfferLetterCheckItemLabel>
      </OfferLetterCheckItemInfo>
      <OfferLetterCheckItemButtons>
        <OfferLetterPassFailButton
          $variant="pass"
          $selected={status === 'pass'}
          onClick={() => handleToggle('pass')}
          aria-label={`Mark "${item.label}" as pass`}
          data-testid={`olv-check-${item.id}-pass`}
        >
          ✓
        </OfferLetterPassFailButton>
        <OfferLetterPassFailButton
          $variant="fail"
          $selected={status === 'fail'}
          onClick={() => handleToggle('fail')}
          aria-label={`Mark "${item.label}" as fail`}
          data-testid={`olv-check-${item.id}-fail`}
        >
          ✗
        </OfferLetterPassFailButton>
      </OfferLetterCheckItemButtons>
    </OfferLetterCheckItemRow>
  );
};

export default OfferLetterCheckItem;
